import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StarProIcon } from '../../../../shared/Icons';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';

const CampaignPackageView = () => {
    const { company } = useSelector((state: IAllStates) => state.auth.user);
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="mt-2">
            {company?.package.isShownToUser ? (
                <>
                    <div className="d-flex align-items-center text-muted">
                        {t('brand.package.notAvailableIn')}
                        {/* <h6 className='my-0 mx-1'>{t('brand.package.basic')}</h6>
                         {t('brand.package.subscriptionPackage')} */}
                    </div>
                    <div className="d-flex align-items-center text-muted">
                        <span
                            className="text-primary text-underline cursor-pointer"
                            onClick={() => navigate(InternalRoutes.BRAND_PACKAGES)}
                        >
                            {t('brand.package.upgradeTo')}
                        </span>
                        <StarProIcon width="50" classes="mx-2" height="50" />
                        {t('brand.package.addMoreCampaigns')}
                    </div>
                </>
            ) : (
                <h6 className="mb-0 text-muted">{t('brand.package.info_about_feature')}</h6>
            )}
        </div>
    );
};

export default CampaignPackageView;
